
import React, { useState } from 'react';
import { Row, Col, Card, CardTitle, CardSubtitle, Button } from 'reactstrap';
import { useNavigate } from 'react-router-dom';

//Components
import TextField from '../../../components/TextField';
import EsqueceuSenhaMunicipe from './Components/EsqueceuSenhaMunicipe';
//Api
import usuario_api from '../../../api/usuario_api';

//Helpers
import { showMessage } from '../../../helpers/message';
import mascaras from '../../../helpers/mascaras';

//context
import { useAuth } from '../../../context/auth';

export default function LoginMunicipe() {
    const navigate = useNavigate();

    //Função de login
    const { signIn, setLoading } = useAuth();

    //Estado de controle dos dados de login
    const [login, setLogin] = useState({
        username: "",
        password: ""
    });

    //Estado de controle de visibilidade da tela de recuperar senha
    const [esqueceuSenha, setEsqueceuSenha] = useState(false);

    //Função de onChange dos campos da tela inicial
    const onChange = (e) => {
        const { name, value } = e.target;
        setLogin({
            ...login,
            [name]: value
        })
    }

    //Função de envio dos dados 
    const onSubmit = () => {
        setLoading(true);
        usuario_api.authenticateMunicipe(login).then(response => {
            signIn(response.data);
            navigate("/municipe/requerimento");
        }).catch(e =>{
            showMessage("Aviso", e.message, "error", null)
            })
            .finally(f => setLoading(false));
    }

    if (esqueceuSenha)
        return <EsqueceuSenhaMunicipe btnVoltar={() => setEsqueceuSenha(false)} />
    return (
        <div className='mainContainerLogin'>
            <Card className='w-75' style={{ marginTop: "10vh", border: "none", padding: "1rem" }}>
                <Row className='p-4'>
                    <Col lg='6' md='12' className='text-center d-flex flex-column justify-content-center' style={{ borderRight: "1px solid #ccc" }}>
                        <div className="mb-3">
                            <img src={require('../../../assets/img/logo.png')} className='img-logo' alt="logo do sistema GAIA" />
                        </div>
                        <CardTitle tag={'h4'} style={{ color: "#666" }} className='mb-2 font-weight-normal'>Seja bem vindo ao GAIA </CardTitle>
                        <CardSubtitle tag="h5" style={{ color: "#ccc", fontSize: '16pt' }} className='mb-2'>
                            Sistema de Gestão Arbórea
                        </CardSubtitle>
                        <CardSubtitle tag="h6" style={{ color: "#ccc", fontSize: '12pt' }} className='mb-4  d-flex align-items-center justify-content-center'>
                            <div style={{ color: "#ccc", width: "80%" }}>
                                Para realizar algum requerimento faça login ou <span role='button' className='text-primary fw-bold' onClick={() => navigate("/auth/cadastre-se")}>cadastre-se</span>
                            </div>
                        </CardSubtitle>
                    </Col>
                    <Col lg='6' md='12' className='text-center d-flex flex-column justify-content-around '>
                        <CardTitle tag={'h4'} className=' text-center' style={{ color: "#666" }}>Dados de acesso</CardTitle>
                        <TextField mask={mascaras.cpfcnpjMask} label={"CPF/CNPJ"} onChange={onChange} value={login.username} name={"username"} />
                        <TextField label={"Senha"} type={'password'} onChange={onChange} value={login.password} name={"password"} />
                        <div className='w-100 d-flex align-items-center justify-content-end text-secondary mb-3'>
                            <span role='button' onClick={() => setEsqueceuSenha(true)}>Esqueceu a senha?</span>
                        </div>
                        <div>
                            <Button color='success' style={{ width: "80%" }} onClick={onSubmit}>
                                Entrar
                            </Button>
                        </div>
                    </Col>

                </Row>
            </Card>
        </div>
    )
}